module.exports = __webpack_public_path__ + "img/challenge_ad.eabe4e21.png";